export enum ContractTypes {
  TipoContratoInvalido = 0,
  ClienteFinal = 11,
  Trade = 14,
  Gnl = 16,
  ClienteComercial = 17,
  ClienteExtendido = 20,
  Financiero = 23,
  Electricidad = 1011
}
